import React from "react";
import { Table, Form, Button, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import xss from "xss";

import { fetchStufen, setStufen, resetKonditionStufe } from "../reducers/konditionen-reducer";
import ConditionsTableHeader from "./conditionsTableHeader";
import { DeleteIcon, AddIcon } from "../utils/components/icons";
import CONFIG from "../config";
import { console, formatCurrency } from '../utils/functions';
import { DeleteRangeTooltip } from './components/DeleteRangeTooltip';
import { Kondition } from './components';

const MAX_STUFE = 5;

class ConditionsRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stufen: [],
      labels: [],
      aktiveKonditionen: this.props.aktiveKonditionen,
      showTooltip: false,
      tooltip: "",
      isDirty: false,
      invalid: []
    };
    this.tooltipTimeout = 5000;
    this.t = null;

    // bind event listeners to this
    this.changeKondition = this.changeKondition.bind(this);
    this.changeStufenWert = this.changeStufenWert.bind(this);
    this.updateStufenWert = this.updateStufenWert.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.addStufe = this.addStufe.bind(this);
    this.deleteStufe = this.deleteStufe.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate() {
    if (this.state.aktiveKonditionen !== this.props.aktiveKonditionen && !this.state.isFetching) {
      this.loadData(this.props.aktiveKonditionen);
    }
  }

  loadData = async (appType) => {
    if (this.state.isFetching) return;
    const shopAppType = CONFIG.getShopConfig({
      edelmetall: "edelmetall",
      sorten: "sorten"
    });
    if (!appType) appType = this.state.aktiveKonditionen || this.props.aktiveKonditionen || shopAppType;
    this.setState({ isFetching: true });
    let konditionRequestStufen = this.props.configStorage.getRequestData(appType + "Stufen");
    if (this.props.configStorage.isBLBAdmin() && !this.props.mandantStorage.isBLBAdmin()) {
      konditionRequestStufen.params = { gpNummer: this.props.mandantStorage.gpNummer };
    }
    // console.log("loadData", appType, this, konditionRequestStufen)
    try {
      await this.props.dispatch(fetchStufen({ requestData: konditionRequestStufen, appType })).unwrap();
    } catch (e) {
      console.log("k1", e);
      this.setState({ isFetching: false, error: e.message, stufen: [] });
      return;
    }
    const stufen = this.props.konditionenStorage.getStufen();
    this.setState({ isFetching: false, error: null, stufen, aktiveKonditionen: appType, isDirty: false });
  };

  isInvalid() {
    let lastStufenWert = 0;
    let invalid = this.state.invalid.length > 0;
    this.stufen.forEach(s => {
      if (s.stufenWert <= lastStufenWert && s.kennziffer !== this.props.konditionenStorage.DEFAULT_KENNZIFFER) invalid = true;
      lastStufenWert = s.stufenWert;
      s.konditionen.forEach(k => {
        const min = k.isMaKond ? -5 : 0;
        if (k.value < min || k.value > 10 || !k.value === "") invalid = true;
      });
    });
    return invalid;
  }

  get stufen() {
    return this.state.stufen || this.props.konditionenStorage.getStufen();
  }

  addStufe(e) {
    if (!e) return;
    let stufen = this.stufen;
    const row = stufen.length;
    const newItem = this.props.konditionenStorage.getNewStufe(row);
    newItem.kennziffer = row;
    newItem.stufenWert = row > 1 ? stufen[row - 1].stufenWert + 1 : 1;
    newItem.bezeichnung = 'Band ' + row;
    newItem.added = true;
    stufen.push(newItem);
    if (!this.state.showTooltip) {
      this.setState({ stufen, isDirty: true, showTooltip: true, tooltip: "Neue Zeilen werden erst nach 'Übernehmen' gespeichert." });
      this.t = setTimeout(() => {
        this.setState({ showTooltip: false });
        this.t = null;
      }, this.tooltipTimeout);
    } else {
      if (this.t) clearTimeout(this.t);
      this.setState({ stufen, isDirty: true, showTooltip: false });
      this.t = null;
    }
    this.onChange({ updateStufen: stufen });
  }

  deleteStufe(e) {
    if (!e) return;
    const target = e.currentTarget || e.target;
    const row = Number(target.dataset.row);
    const stufen = this.stufen.map((s, idx) => {
      if (idx === row) return null;
      if (idx < row) return s;
      s.setRow(idx - 1);
      if (s.kennziffer !== this.props.konditionenStorage.DEFAULT_KENNZIFFER) s.bezeichnung = "Band " + (idx - 1);
      return s;
    }).filter(s => !!s);
    if (!this.state.showTooltip) {
      this.setState({ showTooltip: true, tooltip: "Gelöschte Zeilen werden erst nach 'Übernehmen' entfernt." });
      this.t = setTimeout(() => {
        this.setState({ isDirty: true, showTooltip: false });
        this.t = null;
      }, this.tooltipTimeout);
    } else {
      if (this.t) clearTimeout(this.t);
      this.setState({ isDirty: true, showTooltip: false });
      this.t = null;
    }
    this.onChange({ updateStufen: stufen });
  }



  resetToDefault = async (e) => {
    const idx = Number(e.currentTarget.dataset.field);
    const mapping = ['emBpBuy', 'emMaBuy', 'emWlBuy'];
    const resetEndpoint = mapping[idx];

    if (!resetEndpoint) return;

    this.setState({ isFetching: true, error: null });
    try {
      const { aktiveKonditionen } = this.state;
      const konditionRequestStufen = this.props.configStorage.getRequestData(aktiveKonditionen + "Stufen", "post");
      await this.props.dispatch(resetKonditionStufe({ requestData: konditionRequestStufen, resetEndpoint })).unwrap();

      // Reload data to reflect changes
      await this.loadData(aktiveKonditionen);

      if (typeof this.props.onChange === "function") {
        this.props.onChange();
      }
    } catch (err) {
      console.log("k3", err);
      this.setState({ isFetching: false, error: err.message });
    }
  };

  onChange(change) {
    if (!change) return;
    if (change.stufe) {
      let stufen = Array.isArray(this.state.stufen) ? this.state.stufen : [];
      let item = stufen.find(i => i.row === change.stufe.row);
      if (!item && change.data) {
        item = change.data;
        stufen.push(item);
      }
      if (!item) return;
      item.setKondition(change.stufe.value, change.stufe.col);
      this.setState({ isDirty: true, stufen });
    } else if (change.stufenWert && !isNaN(change.stufenWert.value)) {
      let stufen = Array.isArray(this.state.stufen) ? this.state.stufen : [];
      let item = stufen.find(i => i.row === change.stufenWert.row);
      if ((!item && change.data) || item.kennziffer === this.props.konditionenStorage.DEFAULT_KENNZIFFER) {
        item = change.data;
        stufen.unshift(item);
      }
      if (!item) return;
      item.stufenWert = change.stufenWert.value;
      item.changed = true;
      this.setState({ isDirty: true, stufen });
    } else if (Array.isArray(change.updateStufen)) {
      this.setState({ isDirty: true, stufen: change.updateStufen });
    }
  }

  changeKondition({ value, kondition, invalid }) {
    if (!kondition) return;
    const row = kondition.row;
    const col = kondition.col;
    let item = this.stufen.find(i => i.row === row);
    if (!item) return;
    const invalidKey = `r${row}c${col}`;
    if (invalid) {
      this.setState({ invalid: [...this.state.invalid, invalidKey] });
    } else {
      if (this.state.invalid.find(k => k === invalidKey)) {
        this.setState({ invalid: this.state.invalid.filter(k => k !== invalidKey) });
      }
    }
    if (!isNaN(value)) this.onChange({ stufe: { row, col, value }, data: item });
  }

  onKeyPress(e) {
    if (!e || e.key !== "Enter") return;
    // do not send Form on RETURN
    e.preventDefault();
    e.currentTarget.blur();
    return false;
  }

  changeStufenWert(e) {
    const target = e?.currentTarget || e?.target;
    if (!target) return;
    const row = Number(target.dataset.row);
    const item = this.stufen[row];

    let value = xss(e.target.value);
    const data = item.clone(item);
    data.stufenWert = value;
    data.bezeichnung = "Band " + data.row;
    data.kennziffer = row;
    this.onChange({ stufenWert: { row: item.row, value }, data });
  }

  updateStufenWert(e) {
    const target = e?.currentTarget || e?.target;
    if (!target) return;
    const row = Number(target.dataset.row);
    const item = this.stufen[row];
    target.value = Number(item.stufenWert);
    this.onChange({ stufenWert: { row, value: Number(item.stufenWert) }, data: item });
  }

  renderListe() {
    const stufen = this.stufen;
    return stufen.map((item, idx) => {
      const value = Number(item.stufenWert);
      const hasValue = !isNaN(value) && item.kennziffer !== this.props.konditionenStorage.DEFAULT_KENNZIFFER;
      let invalid = (value < 0) || (idx > 0 && value <= Number(stufen[idx - 1].stufenWert));
      let added = !!this.state.stufen[idx]?.added;
      let dirty = added || item.changed;
      const prefix = hasValue && !this.props.readOnly
        ? "> "
        : "> " + formatCurrency(value);
      return (
        <tr key={`row${item.row}`} className="align-items-end" added={added.toString()}>
          <td aria-label="Band" className="kennziffer">{idx + 1}</td>
          <td aria-label="Gegenwert" className="bezeichnung">
            {hasValue && !this.props.readOnly
              ? <Form.Group controlId={`band-${idx}`} className="input-group">
                <span className="me-one">{prefix}</span>
                <Form.Label visuallyHidden="true">Band {idx}</Form.Label>
                <Form.Control
                  className={
                    "text-end pt-0 pb-0"
                    + (dirty ? " dirty mark" : "")
                    + (invalid ? " is-invalid" : "")
                  }
                  maxLength="3"
                  size="3"
                  value={item.stufenWert}
                  type="number"
                  step="any"
                  min="0"
                  required
                  data-row={idx}
                  onChange={this.changeStufenWert}
                  onBlur={this.updateStufenWert}
                  onKeyPress={this.onKeyPress}
                  readOnly={this.props.readOnly}
                />
                <span className="input-text pt-0 pb-0">€</span>
              </Form.Group>
              : <div className="input-text text-end pt-0 pb-0">{prefix}</div>
            }
          </td>
          {item.konditionen
            ? item.konditionen.map((k, nr) => {
              return (
                <td
                  key={`stufe${k.row}_${k.col}`}
                  aria-label={k.label || ""}
                  className={nr === 0 ? "column-1" : null}
                >
                  <Kondition
                    editMode={!this.props.readOnly}
                    kondition={k}
                    showEditButtons={false}
                    changeKondition={this.changeKondition}
                  />
                </td>
              );
            })
            : null
          }
          {!this.props.readOnly
            ? <td className="aktion">
              {hasValue && idx > 0
                ? <Button
                  type="button"
                  className="aktion"
                  data-row={item.row}
                  onClick={this.deleteStufe}
                  variant="danger"
                >
                  <DeleteIcon />
                </Button>
                : null
              }
              {stufen.length < MAX_STUFE && idx === 0
                ? <Button
                  type="button"
                  className="aktion"
                  onClick={this.addStufe}
                  variant="default"
                >
                  <AddIcon />
                </Button>
                : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }

  async onSubmit(e) {
    this.setState({ isFetching: true });
    let stufenData = this.state.stufen.map(s => {
      const ret = s.stufenWert ? { stufenWert: s.stufenWert } : {};
      if (Array.isArray(s.konditionen)) {
        s.konditionen.forEach(k => {
          ret[k.field] = k.value;
        });
      }
      return ret;
    });
    const konditionRequestStufen = this.props.configStorage.getRequestData(this.state.aktiveKonditionen + "Stufen");
    try {
      await this.props.dispatch(setStufen({ requestData: konditionRequestStufen, stufenData, appType: this.state.aktiveKonditionen })).unwrap();
    } catch (e) {
      console.log("k2", e);
      this.setState({ isFetching: false, error: e.message });
      return;
    }
    const data = this.props.konditionenStorage.getItems();
    this.setState({ data, isDirty: false, isFetching: false, error: this.props.konditionenStorage.error });
    if (typeof this.props.onChange === "function" && !this.props.konditionenStorage.error) this.props.onChange();
  }

  render() {
    if (!this.stufen.length) {
      if (this.state.error) {
        return <Alert variant="danger">Fehler beim Laden der Stufen: {this.state.error}</Alert>;
      }
      return <div>{this.props.children}</div>;
    }
    const showReset = true;
    const lastChange = this.props.konditionenStorage.getStufenLastChange();
    const modifiedBy = this.props.konditionenStorage.getStufenModifiedBy?.() || "";
    return <Form onSubmit={this.onSubmit}>
      <h3>Optionale Konditionsanpassung (Prozentwerte)</h3>
      <p className="fs-6">
        Hinweis: Dieser Bereich ermöglicht Ihnen eine Konfiguration der Prozentwerte in Abhängigkeit vom Produktpreis
        (maßgeblich ist der Standard Verkaufspreis der BayernLB). Bei jeder Kursanpassung durch die BayernLB werden die
        definierten Schwellen geprüft und die jeweils festgelegten Prozentwerte automatisch in die im Shop angezeigten
        Kundenkurse mit eingerechnet.
      </p>
      {this.state.error
        ? <div className="alert alert-danger fs-6 p-1">{this.state.error}</div>
        : null
      }
      <Table id={this.props.id} striped bordered responsive>
        <ConditionsTableHeader
          variant="range"
          liste={this.stufen}
          labels={this.props.labels}
          defaultWerte={this.props.defaultWerte}
          dirty={this.props.dirty}
          onChange={this.onChange}
          readOnly={this.props.readOnly}
          onReset={this.resetToDefault}
        />
        <tbody>
          {this.renderListe()}
        </tbody>
      </Table>
      {lastChange
        ? <div className="d-flex w-100 fs-6 justify-content-end">
            {modifiedBy ? <span className="me-auto">{modifiedBy}</span> : <span className="me-auto" />}
            Letzte Änderung: {lastChange}
          </div>
        : null
      }
      <div className="row">
        <div className="col-md-2">
          {showReset && !this.props.readOnly
            ? <DeleteRangeTooltip
              show={this.state.showTooltip}
              tooltip={this.state.tooltip}
            >
              <Button
                disabled={this.isInvalid() || this.props.editMode}
                title="Diese Werte speichern"
                variant="warning"
                onClick={this.onSubmit}
              >
                Übernehmen
              </Button>
            </DeleteRangeTooltip>
            : null
          }
        </div>
        <div className="col">
          {this.isInvalid()
            ? <div className="alert alert-danger fs-6 p-1">Die Sortierung der Stufen ist nicht aufsteigend oder ein Prozent Wert liegt außerhalb des erlaubten Bereichs oder hat mehr als 2 Nachkommastellen</div>
            : null
          }
          {!this.isInvalid() && this.state.isDirty
            ? <div className="alert alert-danger fs-6 p-1">Daten sind noch nicht gespeichert. Bitte speichern Sie die Daten mit dem „Übernehmen“-Button</div>
            : null
          }
        </div>
      </div>
    </Form>;
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    konditionenStorage: store.konditionenStorage,
    mandantStorage: store.mandantStorage,
  };
})(ConditionsRange);
